<template>
  <div class="product-template __donate __limited-edu __limited-edu--custom2023 __limited-edu--custom2023-team4">
    <div class="container pd-sm-0">
      <div class="col-md-push-2 col-md-8">
        <div class="logo">
          <img src="/static/img/ttdrxlimited-edu/logo-limitededucation-talenthai.png" alt="Logo DESIGNERS’ ROOM & TALENT THAI PROMOTION 2023" class="img-responsive ma-auto d-block" />
        </div>
        <h1 class="img-logo">
          <img src="/static/img/ttdrxlimited-edu/header-title-2023.png" alt="DESIGNERS’ ROOM & TALENT THAI PROMOTION 2023" class="img-responsive ma-auto d-block" />
        </h1>
        <h2 class="product-custom-title text-center" v-html="product.meta.product_custom_title"></h2>
      </div>
    </div>


    <div class="container pd-sm-0">
      <div class="col-md-push-1 col-md-10">
        <div class="product product--inline">
          <div class="product__block--form ">
            <div class="radius block shadow ">
              <product-donate-choice
                :show-donate-type="true"
                :product="product"
                v-model="product.price"
                ref="donateChoice"
                classes="col-1-5"
              />

              <div
                v-if="product.price > 0"
                class="sumary-amount mb-15"
              >
                <table class="sumary-amount-detail">
                  <tbody>
                    <tr>
                      <td class="first-row">ใช้ไป</td>
                      <td class="first-row text-right"><strong><span>{{ totalProductPrice }}</span> / {{ product.price }} บาท</strong></td>
                    </tr>
                    <tr>
                      <td>จำนวนของ</td>
                      <td class="text-right"><strong>{{ selectedProductCount }} ชิ้น</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="form__wrapper mt-15 mb-15 _clearboth">

                <!-- NO Option -->
                <div class="form__section">
                  <label class="form__radio-lg">
                    ไม่ต้องการรับของ
                    <input
                      v-model="attributes.info.rewardProduct"
                      class=""
                      type="radio"
                      name="optionsRadios"
                      value=""
                      @click="clearSelectedProducts"
                    />
                    <span class="checkmark"></span>
                  </label>
                </div><!-- end form section -->

                <div
                  v-for="(p, i) in customProducts"
                  :key="i"
                  class="form__section"
                >
                  <label class="form__radio-lg" :class="{disable: !canSelectReward(p)}">
                    รับ{{ p.title }} <span>{{ p.price }} บาท</span><br />
                    <div v-if="p.description" class="product-option-description">{{ p.description }}</div>
                    <div
                      v-if="p.title === attributes.info.rewardProduct && error.rewardConfigSize"
                      class="alert alert--error mt-5"
                      ref="error"
                    >
                      {{ error.rewardConfigSize }}
                    </div>
                    <input
                      v-model="attributes.info.rewardProduct"
                      class=""
                      type="radio"
                      name="optionsRadios"
                      :value="p.title"
                      :disabled="!canSelectReward(p)"
                      @click="onClickSelectReward"
                    />
                    <span class="checkmark"></span>
                  </label>

                  <transition name="slide-down">
                    <div
                      v-show="p.title === attributes.info.rewardProduct"
                      class="product-variation--wrapper slide-down-wrapper"
                      :class="{disable: !canSelectReward(p)}"
                    >
                      <div
                        v-for="variation in p.variations"
                        :key="variation.title"
                        class="product-variation--column"
                        :class="{ 'product-variation--column-full': p.variations.length === 1 }"
                      >
                        <div
                          class="product-variation--item"
                          :class="{
                            selected: selectedProducts[variation.value].quantity > 0
                          }"
                        >
                          <!-- Title -->
                          <div class="mb-10">
                            <strong>{{ variation.title }}</strong>
                          </div>

                          <!-- Thumbnail -->
                          <Thumbnail
                            :images="variation.images"
                          />

                          <!-- Quantity -->
                          <div class="product-quantity--wrapper">
                            <div class="product-quantity--title">เลือกจำนวน</div>
                            <div class="product-quantity--control">
                              <button
                                class="product-quantity--button"
                                @click.prevent="decreaseProductQuantity(variation.value)"
                                :disabled="selectedProducts[variation.value].quantity === 0"
                              >
                                -
                              </button>
                              <span class="product-quantity--quantity">{{ selectedProducts[variation.value].quantity }}</span>
                              <button
                                class="product-quantity--button"
                                @click.prevent="increaseProductQuantity(variation.value)"
                                :disabled="totalProductPrice + p.price > product.price"
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>

              </div><!-- end form wrapper -->

              <donor-info v-model="attributes.info.name"
                class="pt-15" />

              <page-selector
                :product="product"
                v-model="attributes.page"
                v-show="false" />

              <product-cart-action
                :product="product"
                :attributes="attributes"
                :initialQuantity="1"
                :addToCartButton="false"
                :buyNowButton="false"
                :style="{margin:0}"
                ref="cartAction" />
                <div class="text-center">
                    <div class="alert alert--info">** โปรดตรวจสอบรายการรับของที่ระลึกให้ถูกต้องก่อนกดยืนยันการบริจาค **</div>
                </div>
              
              <div class="text-center">
                <button type="button" class="btn btn--purple btn--default" @click.prevent="donate">บริจาค</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'
  import Thumbnail from '@/components/Thumbnail'

  export default {
    name: 'ProductTemplateCustom2023-team1',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice,
      Thumbnail
    },

    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },

    data () {
      return {
        attributes: {
          info: {
            name: '',
            rewardProduct: ''
          },
          page: ''
        },
        error: {
          rewardConfigSize: false
        },
        selectedSize: {},
        selectedProducts: {},
        currentThumbnailImage: ''
      }
    },

    computed: {
      customProducts () {
        return JSON.parse(this.product.meta.product_custom_products)
      },

      totalProductPrice () {
        return Object.values(this.selectedProducts).reduce((sum, product) => {
          return sum + (product.price * product.quantity)
        }, 0)
      },

      remainingBalance () {
        return this.isRewardDisabled ? 0 : this.product.price - (this.totalRewardItems * this.itemPrices[this.currentRewardIndex])
      },

      selectedProductCount () {
        return Object.values(this.selectedProducts).reduce((sum, product) => {
          return sum + product.quantity
        }, 0)
      }
    },

    created () {
      this.initSelectedProducts()
    },

    methods: {
      initSelectedProducts () {
        const selectedProducts = {}
        for (const product of this.customProducts) {
          if (product.variations) {
            for (const variation of product.variations) {
              selectedProducts[variation.value] = {
                price: variation.price || product.price,
                quantity: 0
              }
            }
          }
        }
        this.selectedProducts = selectedProducts
      },

      validate () {
        this.error.rewardConfigSize = false

        let valid = true
        const {info} = this.attributes

        // Validate selection.
        if (info.rewardProduct) {
          if (this.selectedProductCount === 0) {
            this.error.rewardConfigSize = 'กรุณาเลือกของ'
            valid = false
          } else if (this.totalProductPrice > this.product.price) {
            this.error.rewardConfigSize = 'เลือกของเกินจำนวนบริจาค'
            valid = false
          }
        }

        if (!valid) {
          setTimeout(() => {
            this.scrollToElement(this.$refs.error[0])
          }, 300)
        }

        return valid
      },

      scrollToElement (el) {
        const rect = el.getBoundingClientRect()
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const top = rect.top + scrollTop

        window.scrollTo({ left: 0, top: top - 60, behavior: 'smooth' })
      },

      async donate () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }

        if (!this.validate()) {
          return
        }

        // Update reward info.
        if (this.attributes.info.rewardProduct) {
          // Copy info to update size before re-assign back.
          const info = JSON.parse(JSON.stringify(this.attributes.info))

          // Update selected products.
          Object.keys(this.selectedProducts).forEach(key => {
            const product = this.selectedProducts[key]
            if (product.quantity > 0) {
              info[key] = product.quantity
            }
          })

          // Re-assign info back to attributes.
          this.attributes.info = info
        }

        // Clear previous cart info.
        await this.$store.dispatch('clearCart')

        // Add donation product to cart and go to checkout.
        this.$refs.cartAction.buyNow()
      },

      canSelectReward (product) {
        return this.product.price >= product.price
      },

      onClickSelectReward (e) {
        this.attributes.info.rewardProduct = e.currentTarget.value
        this.clearSelectedProducts()
      },

      increaseProductQuantity (product) {
        this.selectedProducts[product].quantity += 1
        this.error.rewardConfigSize = ''
      },

      decreaseProductQuantity (product) {
        this.selectedProducts[product].quantity -= 1
        this.error.rewardConfigSize = ''
      },

      clearSelectedProducts () {
        this.error.rewardConfigSize = ''
        Object.keys(this.selectedProducts).forEach(key => {
          this.selectedProducts[key].quantity = 0
        })
      }
    },

    watch: {
      'product.price': function (amount) {
        this.clearSelectedProducts()
        // Reward product is selected.
        if (amount && this.attributes.info.rewardProduct) {
          // Check donate amount cover selected reward product or not.
          const product = this.customProducts.find(product => product.title === this.attributes.info.rewardProduct)
          if (amount < product.price) {
            this.attributes.info.rewardProduct = ''
          }
        } else if (!amount) {
          this.attributes.info.rewardProduct = ''
        } else {
          this.attributes.info.rewardProduct = this.customProducts[0].title
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

.product-custom-title {
  color: #fff;
}

.product-option-description {
  margin-top: 4px;
  font-weight: 300;
  color: gray;
}

.product-quantity {
  &--wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
    border-top: 1px solid #ccc;
  }
  &--title {
    font-size: 1.25rem;
    font-weight: 500;
  }

  &--control {
    display: flex;
  }

  &--quantity {
    line-height: 40px;
    width: 40px;
    text-align: center;
    font-weight: bold;
    font-size: 1.5rem;
  }

  &--button {
    font-size: 2rem;
    border-radius: 8px;
    border: none;
    background-color: #D8D8D8;
    color: #808080;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    text-decoration: none;
    cursor: pointer;
    line-height: 1;

    &:hover {
      background-color: #CCC;
    }
  }
}

.product-variation {
  &--wrapper {
    display: flex;
    padding: 16px;
    margin-left: -0.5rem;
    margin-right: -0.5rem;
    flex-wrap: wrap;
  }


  &--column {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 50%;
    max-width: 50%;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    margin-block: 0.5rem;

    // &-full {
    //   flex-basis: 100%;
    //   max-width: 100%;
    // }
  }

  &--item {
    background-color: #fff;
    padding: 16px;
    border: 4px solid transparent;
    font-size: 90%;
    line-height: 1.5;

    &.selected {
      border-color: #5ABE0A;
    }
  }
}

  h1.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    font-size: 2em;
    font-weight: 400;
    margin-bottom: 15px;
  }

  h3.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
  }
  .block { background: #fff; }
  .btn--default {
    margin: 20px auto 10px;
  }

  .slide-down-wrapper {
    margin-top: 15px;
    margin-bottom: -15px;
    background-color: #EEEFEB;
  }

  .current-thumbnail-wrapper {
    cursor: zoom-in;
  }

  .thumbnail-wrapper {
    border: 1px solid transparent;
    cursor: pointer;

    &.selected {
      border-color: #F8941D;
    }
  }

  .size-choice {
    cursor: pointer;

    &.only-one {
      .number-field {
        display: none;
      }
    }

    &.active {
      border: 1px solid #F8941D;
    }
    
  }
</style>



// WEBPACK FOOTER //
// custom2023-team4.vue?731fbfc8